export default "import { type Routes } from '@angular/router';\n\nexport const routes: Routes = [];\n"